module.exports = __webpack_public_path__ + "static/Viking-Traders-and-Explorers-25524c5cf934ab5ebd95a55b54c43366.pdf";